import { ethers } from "ethers";
import AroundRouterABI from "../abis/AroundRouter.json";

export class AroundRouterContract {
  contract;
  constructor(contractAddress, providerOrSigner) {
    this.contract = new ethers.Contract(contractAddress, AroundRouterABI.abi, providerOrSigner);
  }
  async createMarket(params) {
    const {
      marketType,
      period,
      expectVirtualLiquidity,
      collateral,
      creator,
      quest,
    } = params || {};
    return await this.contract.createMarket({
      marketType: Number(marketType),
      period: ethers.toBigInt(period),
      expectVirtualLiquidity: ethers.toBigInt(expectVirtualLiquidity),
      collateral: String(collateral),
      creator: String(creator),
      quest: String(quest || ""),
    });
  }
}
